import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

/**
 * Rejects any entry that isn't uppercase, matching the convention in `news_and_guides_visibility`
 * — consumers compare against `countryCode.toUpperCase()`.
 */
const normalizeSupportedTargetCountries = (value: unknown): readonly string[] => {
	const countries = createShapeNormalizer({ type: 'array', shape: { type: 'string' } })(value);
	for (const country of countries) {
		if (country !== country.toUpperCase()) {
			throw new Error(`DMI supported target country "${country}" must be uppercase`);
		}
	}
	return countries;
};

export const FCM_SAP_DMI_SUPPORTED_TARGET_COUNTRIES = defineFcm('sap_dmi_supported_target_countries')
	.asJson(normalizeSupportedTargetCountries)
	.withDefault([])
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		// Locale-scoped so DMI can ramp independently of `sap_scope_location_inference` within the
		// same locale, even once the country list itself is identical everywhere.
		supportedGroups: { locales: true },
		context: 'SAP DMI inference',
		description:
			'List of uppercase target-country codes DMI supports for the Start a Petition (SAP) AI flow (e.g. `["US"]`). SAP fires the `inferDecisionMakers` mutation only when the scope/location inference resolves a LOCAL target in one of these countries, and tracks/logs the result. Empty list disables the call entirely. Expanding DMI to a new country is a config change here, not a front-end deploy — the list itself is the gate, no separate on/off toggle. CHANGE-98274',
		template: ['US'],
	});
